<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.813" height="21.527" viewBox="0 0 21.813 21.527">
    <g transform="translate(0.752 0.762)">
      <path :style="{stroke:color}" class="a" d="M22,11.08V12a10,10,0,1,1-5.93-9.14" transform="translate(-2 -1.994)"/>
      <path :style="{stroke:color}" class="a" d="M22,4,12,14.01l-3-3" transform="translate(-2 -1.994)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "AcceptIcon",
  props: {color: String}
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #57b98f;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}
</style>
